import { CheckoutActivityLog } from "./CheckoutActivityLog";

export function logLocation(calledIndexModifier = 2, visitorId?: string) {
    const e = new Error();
    const fullStack = e.stack?.split("\n");
    const stackElementIndex = (fullStack || [])?.length >= calledIndexModifier ? calledIndexModifier : fullStack?.length || 0;

    const stack = fullStack?.[stackElementIndex]; // 0 = Error, 1 = this function, 2 = caller

    return extractFileAndLine(stack!, visitorId, fullStack, stack);
}

export function extractFileAndLine(stackLine: string, visitorId?: string, fullStack?: string[], stack?: string): string | null {
    const match = stackLine?.match(/\/src\/.*?:\d+/);

    return match ? match[0]?.replace("/src/", "/") : null;
}
